import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import { EASE } from "@/lib/motion";

export default function MobileEstimateBar({ show, estimate, link, label = "Estimated fee" }) {
  const [dismissedFor, setDismissedFor] = useState(null);
  const signature = estimate ? `${estimate.min}-${estimate.max}` : null;

  useEffect(() => {
    if (signature && signature !== dismissedFor && dismissedFor !== null) setDismissedFor(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);

  const visible = show && estimate && dismissedFor !== signature;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="mobile-estimate-bar"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: EASE }}
          className="glass fixed inset-x-4 bottom-4 z-40 flex items-center justify-between gap-3 border border-steel-border p-4 shadow-[0_20px_60px_rgba(0,0,0,0.55)] lg:inset-x-auto lg:bottom-6 lg:left-6 lg:w-auto lg:min-w-[320px] lg:max-w-sm"
        >
          <div className="min-w-0">
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-steel-muted">{label}</p>
            <p className="neon-text font-display text-xl font-medium text-steel-brass">
              ${estimate.min.toLocaleString()} – ${estimate.max.toLocaleString()}
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <Link
              to={link}
              data-testid="mobile-estimate-cta"
              className="flex items-center gap-1.5 bg-steel-accent px-4 py-2.5 text-xs font-semibold text-white"
            >
              Continue <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
            <button
              data-testid="mobile-estimate-dismiss"
              onClick={() => setDismissedFor(signature)}
              className="flex h-9 w-9 items-center justify-center border border-steel-border text-steel-muted transition-colors hover:text-steel-text"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
